export default [{"thumb":"images/Nauen/thumbs/SynagogeNauenBronzerelief.jpg","img":"images/Nauen/SynagogeNauenBronzerelief.jpg"}];